import { ActionReducerMap } from "@ngrx/store";
import { MenuItem } from "primeng/api";
import { draftReducer } from "./draft.reducer";
import { formReducer, FormState } from "./form.reducer";
import { menusReducer } from "./menus.reducer";
import { userReducer, UserState } from "./user.reducer";

export type State = {
  user: UserState;
  form: FormState;
  menus: MenuItem[];
  exist: number;
};

export const reducers: ActionReducerMap<State> = {
  user: userReducer,
  form: formReducer,
  menus: menusReducer,
  exist: draftReducer,
};
